var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg123Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 14.5V7.3H1V5.5H4.6V14.5H2.8ZM19 12.7C19 13.699 18.19 14.5 17.2 14.5H13.6V12.7H17.2V10.9H15.4V9.1H17.2V7.3H13.6V5.5H17.2C17.6774 5.5 18.1352 5.68964 18.4728 6.02721C18.8104 6.36477 19 6.82261 19 7.3V8.65C19 9.00804 18.8578 9.35142 18.6046 9.60459C18.3514 9.85777 18.008 10 17.65 10C18.008 10 18.3514 10.1422 18.6046 10.3954C18.8578 10.6486 19 10.992 19 11.35V12.7ZM11.8 12.7V14.5H6.4V10.9C6.4 9.901 7.21 9.1 8.2 9.1H10V7.3H6.4V5.5H10C10.4774 5.5 10.9352 5.68964 11.2728 6.02721C11.6104 6.36477 11.8 6.82261 11.8 7.3V9.1C11.8 10.099 10.99 10.9 10 10.9H8.2V12.7H11.8Z",
    fill: "#FDBA2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg123Icon);
export default __webpack_public_path__ + "static/media/123-icon.f9502773c7b8356ef5356afd3cad0c16.svg";
export { ForwardRef as ReactComponent };